<template>
    <div class='sub-btn-box'>
        <button @click='$emit("sub-answer")'>{{$t('submit')}}</button>
    </div>
</template>
<script>
export default {
  name: 'SubBtn',
  data () {
    return {

    }
  },
  props: {

  }
}
</script>

<style lang='less' scoped>
    .sub-btn-box{
        width:100%;
        padding:20px;
        overflow: hidden;
        box-sizing: border-box;
    }
    button{
        border:none;
        outline:none;
        padding:0 34px;
        height:32px;
        background:@basic-color;
        color:#fff;
        border-radius:4px;
        text-align:center;
        line-height:32px;
        font-size:18px;
        float:right;
    }
</style>
